// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1hNdE","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3z7Vd"};